module.exports = __webpack_public_path__ + "img/folder.da4e8d5f.svg";